export const mutations = {
    setCargo(state, cargo){
        state.cargo = cargo
    },
    setCargos(state, cargos){
        state.cargos = cargos
    },
    setModalCadastroCargo(state, status){
        state.modalCadastroCargo = status
    },
    setModalExcluirCargo(state, status){
        state.modalExcluirCargo = status
    },
  
}

export default {}